import { QueryClient, QueryCache, MutationCache } from "@tanstack/react-query";
import * as Sentry from "@sentry/react";

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => {
      if (error instanceof Error && error.message === "Unauthorized") return;
      Sentry.captureException(error, {
        tags: { queryKey: JSON.stringify(query.queryKey) },
      });
    },
  }),
  mutationCache: new MutationCache({
    onError: (error) => {
      if (error instanceof Error && error.message === "Unauthorized") return;
      Sentry.captureException(error);
    },
  }),
  defaultOptions: {
    queries: { refetchOnWindowFocus: false },
  },
});
